import { initHeader, initAudienceSwitcher } from './components/header.js';
import { initHeroPhone } from './components/hero-phone.js';
import { initCompanyStrips } from './components/company-strips.js';
import { initCarousel } from './components/carousel.js';
import { initNewsletter } from './components/newsletter.js';
import { initContactsGrid } from './components/contacts-grid.js';
import { initContactsDirectory } from './components/contacts-directory.js';
import { initApplyModal } from './components/apply-modal.js';
import { initLedigaUppdrag } from './components/lediga-uppdrag.js';
import { initKonsultuppdragRoles } from './components/konsultuppdrag-roles.js';

function init() {
    initHeader();
    initAudienceSwitcher();
    initHeroPhone();
    initCompanyStrips();
    initCarousel('.block-offerings', 'offerings', { loop: true });
    initCarousel('.block-case-list', 'case-list');
    initNewsletter();
    initContactsGrid();
    initContactsDirectory();
    initApplyModal();
    initLedigaUppdrag();
    initKonsultuppdragRoles();
}

document.addEventListener('DOMContentLoaded', init);
